import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles, ArrowRight } from "lucide-react";

const banners = [
  {
    tag: "New In · Drop 01",
    title: "Crafted Quietly.",
    subtitle: "Loud in spirit.",
    blurb:
      "Handpicked Indian D2C edits. Light on the planet, heavy on the feels.",
    img: "https://images.unsplash.com/photo-1503160865267-af4660ce7bf2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    accent: "#FFD1D1",
  },
  {
    tag: "Editor's pick",
    title: "Festive, refined.",
    subtitle: "Made to last.",
    blurb: "Slow fashion meets fast checkout. Buy now, wear forever.",
    img: "https://images.unsplash.com/photo-1617039487629-6babdcb2a24b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    accent: "#E8D1FF",
  },
  {
    tag: "Free shipping ₹999+",
    title: "Daily essentials,",
    subtitle: "elevated.",
    blurb: "Beauty, home, wellness — curated, cash on delivery.",
    img: "https://images.unsplash.com/photo-1631730486572-226d1f595b68?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    accent: "#D1FFEB",
  },
];

export const HeroBanner = () => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % banners.length), 5500);
    return () => clearInterval(t);
  }, []);

  const b = banners[i];

  return (
    <div
      data-testid="home-hero-banner"
      className="relative w-full rounded-[28px] overflow-hidden border border-white/50 backdrop-blur-xl backdrop-saturate-150 bg-white/40 shadow-[0_12px_40px_rgba(0,0,0,0.08)]"
    >
      <div className="grid grid-cols-1 md:grid-cols-5 min-h-[360px] md:min-h-[420px]">
        <div className="md:col-span-3 p-6 sm:p-10 flex flex-col justify-between gap-8 relative">
          <div className="flex items-center gap-2 text-xs uppercase tracking-[0.22em] font-medium text-[#064E3B]">
            <Sparkles size={14} strokeWidth={1.5} />
            <span>{b.tag}</span>
          </div>

          <AnimatePresence mode="wait">
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -8 }}
              transition={{ duration: 0.5 }}
              className="space-y-4"
            >
              <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.95] font-light text-[#0B0C10]">
                {b.title}
                <br />
                <span className="italic font-normal">{b.subtitle}</span>
              </h1>
              <p className="text-base sm:text-lg text-neutral-700 max-w-md">
                {b.blurb}
              </p>
            </motion.div>
          </AnimatePresence>

          <div className="flex items-center gap-3">
            <button
              data-testid="hero-shop-now-btn"
              onClick={() =>
                document
                  .getElementById("storefront")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
              className="group inline-flex items-center gap-2 bg-[#0B0C10] text-white rounded-full px-6 py-3 text-sm font-medium tracking-wide hover:-translate-y-0.5 hover:shadow-lg transition-all"
            >
              Shop the drop
              <ArrowRight
                size={16}
                strokeWidth={1.8}
                className="group-hover:translate-x-1 transition-transform"
              />
            </button>
            <div className="flex gap-1.5" data-testid="hero-dots">
              {banners.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setI(idx)}
                  aria-label={`go to banner ${idx + 1}`}
                  className={`h-1.5 rounded-full transition-all ${idx === i ? "w-8 bg-[#0B0C10]" : "w-1.5 bg-[#0B0C10]/30"}`}
                />
              ))}
            </div>
          </div>
        </div>

        <div className="md:col-span-2 relative min-h-[200px] md:min-h-full">
          <AnimatePresence mode="wait">
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 1.03 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.6 }}
              className="absolute inset-0"
            >
              <div
                className="absolute inset-0"
                style={{ background: b.accent, opacity: 0.5 }}
              />
              <img
                src={b.img}
                alt={b.title}
                className="absolute inset-0 w-full h-full object-cover mix-blend-multiply"
              />
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};
